import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getAggregations(date) {
    return axiosIns.get(
      '/v2/eod_report/eod_closing_user_aggregations',
      { params: snakecaseKeys({ date }) },
    )
  },
}
